if (typeof boostPFSThemeConfig !== 'undefined') {
    // Override Settings
    var boostPFSFilterConfig = {
        general: {
            limit: boostPFSConfig.custom.products_per_page,
            /* Optional */
            loadProductFirst: false,
            numberFilterTree: 2,
            showLimitList: '24,36,48',
            // Filter option collapse
            collapseOnPCByDefault: true, // Collapse on PC by default
            collapseOnMobileByDefault: true, // Collapse on Mobile by default
        },
        selector: {
            breadcrumb: '.breadcrumbs-container'
        }
    };
}

(function() {
    BoostPFS.inject(this);

    // Returns true if a variant is a tile *sample* variant.
    // Identified by SKU prefix "SAMP-" or variant metafield custom.is_sample_varaint = True.
    function isSampleVariant(variant) {
        if (!variant) return false;
        // 1) SKU prefix check (primary, always reliable)
        if (variant.sku && String(variant.sku).toUpperCase().indexOf('SAMP-') === 0) {
            return true;
        }
        // 2) Variant metafield custom.is_sample_varaint === True (if Boost syncs variant metafields)
        if (Array.isArray(variant.metafields)) {
            var sampleMf = variant.metafields.find(function(m) {
                return m.namespace === 'custom' && m.key === 'is_sample_varaint';
            });
            if (sampleMf && String(sampleMf.value).toLowerCase() === 'true') {
                return true;
            }
        }
        return false;
    }

    /************************** BUILD PRODUCT LIST **************************/
    function applyDiscount(data) {
        // Find a discount tag (e.g., "10% discount")
        const discountTag = data.tags.find(tag => tag.includes("% discount"));
        if (discountTag) {
            // Extract the numeric value from the discount tag
            const discountPercentage = parseFloat(discountTag.split('%')[0]);
            // Retrieve the original price (assuming data.price is the original price)
            var originalPrice = data.variants[0].price; // Ensure this matches your data structure
            console.log(data);
            // Calculate the new discounted price
            var discountedPrice = originalPrice - (originalPrice * (discountPercentage / 100));
            // Format the new price into HTML
            var compare_at_price_new_html = `<div class="mrk-main-discounted-price price__current price__current--emphasize price__current--on-sale " data-price-container=""><span class="money price__current--min test" data-price-min="">${Utils.formatMoney(discountedPrice)}</span></div>`;
            return compare_at_price_new_html;
        }
        // If there's no discount tag, return an empty string or some default value
        return ''; // Or your default value
    }

    function createDiscountHtmlFromData(data) {
        // Find a discount tag (e.g., "10% discount")
        const discountTag = data.tags.find(tag => tag.includes("% discount"));
        if (discountTag) {
            // Extract the numeric value from the discount tag
            const discountPercentage = parseFloat(discountTag.split('%')[0]);
            return `<div class="discount-offer-text">
                      <p>Extra ${discountPercentage}% off applied</p>
                  </div>`;
        } else {
            // If there's no discount tag, return an empty string
            return '';
        }
    }
    // Build Product Grid Item
    ProductGridItem.prototype.compileTemplate = function(data, index, totalProduct) {
        if (!data) data = this.data;
        if (!index) index = this.index;
        if (!totalProduct) totalProduct = this.totalProduct;
  
        /*** Prepare data ***/
        // console.log("data--"+JSON.stringify(data.metafields));
        const today = new Date();
        let hasPastDate = false;
        let allDatesInFuture = true;
        let anyFutureDate = false; // New variable to track if any date is in the future
        
        data.metafields.forEach(item => {
            // Check if the key is 'back_in_stock_date_from_vendor'
            if (item.key === "back_in_stock_date_from_vendor") {
                const stockDate = new Date(item.value);
                console.log(stockDate, today)
                if (stockDate < today) {
                    hasPastDate = true;
                    allDatesInFuture = false;
                } else if (stockDate > today) {
                    anyFutureDate = true; // Set to true if any future date is found
                }
            }
        });
        if (!hasPastDate) {
            allDatesInFuture = true;
        }

        var images = data.images_info;
        var soldOut = !data.available; // Check a product is out of stock
        var onSale = data.compare_at_price_min > data.price_min; // Check a product is on sale
        var priceVaries = data.price_min != data.price_max; // Check a product has many prices
        // console.log("variants::---" + JSON.stringify(this.data));
        // Get First Variant (selected_or_first_available_variant)
        var firstVariant = data['variants'][0];
        if (Utils.getParam('variant') !== null && Utils.getParam('variant') != '') {
            var paramVariant = data.variants.filter(function(e) {
                return e.id == Utils.getParam('variant');
            });
            if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0];
        } else {
            for (var i = 0; i < data['variants'].length; i++) {
                if (data['variants'][i].available) {
                    firstVariant = data['variants'][i];
                    break;
                }
            }
        }
        /*** End Prepare data ***/
        // Get Template
        var itemHtml = boostPFSTemplate.productGridItemHtml;
        var collection___handle = boostPFSTemplate.handle;
                // --- Promo badge for selected brands (renders directly below the stock status) ---
        // Create a slot right after the stock status token, then fill it based on vendor.
                itemHtml = itemHtml.replace(/{{stockStatus}}/g, '{{stockStatus}}{{sampleAvailable}}{{promoBadge}}');
        var promoBrands = ['crosswater', 'burlington', 'duravit', 'merlyn', 'hansgrohe', 'hib', 'bc designs', 'geberit', 'britton', 'ardex', 'jackoboard', 'tece', 'laufen', 'solidsoft', 'grundfos', 'dunlop', 'bal', 'levtec', 'lithofin'];
        // var promoBrands = ['xxxxxx'];
        var promoBadgeHtml = '';
        if (data.vendor && promoBrands.indexOf(data.vendor.toLowerCase()) !== -1) {
            promoBadgeHtml = '<span class="promo-badge promo-badge--card"><b>EXTRA 10% OFF</b> WITH €1,000+ SPEND ON SELECTED BRANDS</span>';
        }
        itemHtml = itemHtml.replace(/{{promoBadge}}/g, promoBadgeHtml);
                // Free Sample In Stock — only tile products have SAMP- sample variants,
        // so this is inherently tile-scoped. Show when a sample variant is in stock.
        var sampleAvailableHtml = '';
        var sampleInStock = data.variants.filter(function(v) {
            var vSku = (v.sku || '').toUpperCase();
            var isSample = vSku.indexOf('SAMP-') === 0 || String(v.is_sample_varaint).toLowerCase() === 'true';
            return isSample && v.available && parseFloat(v.inventory_quantity) > 0;
        });
                        if (sampleInStock.length > 0) {
                        sampleAvailableHtml =
                '<div class="free-sample-available" style="display:flex;align-items:center;gap:0.5rem;margin-top:4px;font-weight:400;color:#4d4d4d;">' +
                    '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="flex:none;" aria-hidden="true">' +
                        '<rect x="3" y="3" width="7" height="7" rx="1"></rect>' +
                        '<rect x="14" y="3" width="7" height="7" rx="1"></rect>' +
                        '<rect x="3" y="14" width="7" height="7" rx="1"></rect>' +
                        '<rect x="14" y="14" width="7" height="7" rx="1"></rect>' +
                    '</svg>' +
                    '<span>Free Sample In Stock</span>' +
                '</div>';
        }
        itemHtml = itemHtml.replace(/{{sampleAvailable}}/g, sampleAvailableHtml);
        var discounted_Price = applyDiscount(data);
        var discounted_tag = createDiscountHtmlFromData(data);
        const parser = new DOMParser();
        const itemHtmlDoc = parser.parseFromString(itemHtml, 'text/html');
      // console.log("dom parser"+itemHtml);
        const itemElement = itemHtmlDoc.querySelector('[data-collection]');
      // console.log("data collection"+itemElement.outerHTML);
        // Now you can get the attribute from the selected element
        let data__collection;
        if (itemElement) {
            data__collection = itemElement.getAttribute('data-collection');
        } else {
            data__collection = null;
        }
      // console.log("data collection"+data__collection);
        // Add quickBtn
        var itemActionsHtml = buildActions(data, firstVariant);
        itemHtml = itemHtml.replace(/{{itemActions}}/g, itemActionsHtml);
        // Add custom class
        var customClass = 'imagestyle--' + boostPFSConfig.custom.product_grid_image_style;
        if (onSale) customClass += ' productitem--sale';
        if (boostPFSConfig.custom.emphasize_price) customClass += ' productitem--emphasis';
        if (boostPFSConfig.custom.atc_display == 'always' || boostPFSConfig.custom.quick_shop_display == 'always') customClass += ' show-actions--mobile';
        itemHtml = itemHtml.replace(/{{customClass}}/g, customClass);
        var itemImages = '';
        if (images.length > 0) {
            if (images.length > 1 && boostPFSConfig.custom.product_grid_show_second_image) {
                itemImages += buildImage(images[1], '512x', 'productitem--image-alternate');
            }
            itemImages += buildImage(images[0], '512x', 'productitem--image-primary');
        } else {
            itemImages += buildImage(null, '512x', 'productitem--image-primary');
        }
        itemHtml = itemHtml.replace(/{{itemImages}}/g, itemImages);
        // Add Thumbnail
        var itemThumbUrl = images.length > 0 ? Utils.optimizeImage(images[0]['src'], '512x') : boostPFSConfig.general.no_image_url;
        itemHtml = itemHtml.replace(/{{itemThumbUrl}}/g, itemThumbUrl);
        // const find_tag_valus = 'range-Stella';
        // const found = tags_value.find(find_tag_valus);
        // console.log('found', found);
        // Add Label
        var itemLabelsHtml = '';
        if (soldOut) {
            itemLabelsHtml += '<span class="productitem__badge productitem__badge--soldout">' + boostPFSConfig.label.sold_out + '</span>';
        } else {
            if (onSale && boostPFSConfig.custom.product_sales_badge) {
                if (data.price_min == 0 || data.price_min == '0') {
                    var savePrice = data.compare_at_price_max - data.price_max;
                } else {
                    var savePrice = data.compare_at_price_min - data.price_min;
                }
                var percentSavePrice = Math.round(savePrice * 100 / data.compare_at_price_min);
                var percentSavePriceHtml = '<span data-price-percent-saved>' + percentSavePrice + '</span>';
                itemLabelsHtml += '<span class="productitem__badge productitem__badge--sale test" data-badge-sales';
                if (!onSale) itemLabelsHtml += 'style="display: none;"';
                itemLabelsHtml += '>';
                itemLabelsHtml += '<span data-badge-sales-range>';
                switch (boostPFSConfig.custom.product_sales_badge_style) {
                    case 'percent':
                        if (priceVaries) {
                            itemLabelsHtml += boostPFSConfig.label.sale_percentage_range_html.replace(/{{ savings }}/g, percentSavePriceHtml);
                        } else {
                            itemLabelsHtml += boostPFSConfig.label.sale_percentage_single_html.replace(/{{ savings }}/g, percentSavePriceHtml);
                        }
                        break;
                    case 'money':
                        if (priceVaries) {
                            itemLabelsHtml += boostPFSConfig.label.sale_money_range_html.replace(/{{ savings }}/g, Utils.formatMoney(savePrice));
                        } else {
                            itemLabelsHtml += boostPFSConfig.label.sale_money_single_html.replace(/{{ savings }}/g, Utils.formatMoney(savePrice));
                        }
                        break;
                    default:
                        itemLabelsHtml += boostPFSConfig.label.sale;
                        break;
                }
                itemLabelsHtml += '</span></span>';
            }
        }
        // Best Seller badge — triggered by product tag 'best-seller'
        if (data.tags && data.tags.includes('best-seller')) {
            var bsLabel = (boostPFSConfig.label && boostPFSConfig.label.best_seller_badge_label)
                ? boostPFSConfig.label.best_seller_badge_label
                : 'BEST SELLER';
            itemLabelsHtml += '<div class="best-sellers-badge">' + bsLabel + '</div>';
        }
        // Package Deal badge — matches any casing/separator: 'Package-Deal', 'Package Deal', 'package deal', etc.
        if (data.tags && data.tags.some(function(t){ return t.toLowerCase().replace(/[-_\s]/g, '') === 'packagedeal'; })) {
            itemLabelsHtml += '<span class="productitem__badge productitem__badge--package-deal">Package Deal</span>';
        }
        // Wrap all labels in the positioned stack container
        if (itemLabelsHtml !== '') {
            itemLabelsHtml = '<div class="product-badge-stack">' + itemLabelsHtml + '</div>';
        }
        itemHtml = itemHtml.replace(/{{itemLabels}}/g, itemLabelsHtml);
        // Assuming 'variants' is the array of variants from your data
        let allVariants = this.data.variants;
        let allAvailable = true; // Tracks if all variants have inventory_policy 'continue'
        let someAvailable = false; // Tracks if any variant has stock or inventory_policy 'continue'
        let allSoldOut = true;
        let instocklabel = `<div class="icon__with__text"><div class="instock__image wd"><img class="" src="https://cdn.shopify.com/s/files/1/0606/2909/0544/files/3_4de360da-f3ff-401a-8591-2d5d76e9142a.svg?v=1749124995;width=50"></div><span class="instock__text">In Stock </span></div>`;
        let someavailable = `<div class="icon__with__text"><div class="instock__image wd"><img class="" src="https://cdn.shopify.com/s/files/1/0606/2909/0544/files/3_4de360da-f3ff-401a-8591-2d5d76e9142a.svg?v=1749124995;width=50"></div><span class="instock__text">Selected Options In Stock</span></div>`;
        let soldout = "Out of stock";
        allVariants.forEach(variant => {
            // console.log('variant data==>' + JSON.stringify(variant))
            if (variant.inventory_policy !== 'continue' && variant.inventory_quantity <= 0) {
                allAvailable = false; // If any variant doesn't meet the 'continue' policy or has no stock
            } else {
                someAvailable = true; // If at least one variant is available
            }
            if (variant.inventory_policy === 'continue' || variant.inventory_quantity > 0) {
                allSoldOut = false; // If any variant has stock or is allowed to sell when out of stock
            }
        });

//       if(collection___handle == 'always-in-stock'){
//         if (allAvailable && collection___handle == 'always-in-stock') {
//             itemHtml = itemHtml.replace(/{{stockStatus}}/g, instocklabel);
//         }else if (someAvailable) {
//             itemHtml = itemHtml.replace(/{{stockStatus}}/g, someavailable);
//         } else if (allSoldOut) {
//             itemHtml = itemHtml.replace(/{{stockStatus}}/g, soldout);
//         }
//       }
// console.log("anyFutureDate"+anyFutureDate);
//        if (anyFutureDate && collection___handle == 'sonas' || collection___handle == 'lussaro' ) {
//             itemHtml = itemHtml.replace(/{{stockStatus}}/g, someavailable);
//         }else if (allSoldOut) {
//            itemHtml = itemHtml.replace(/{{stockStatus}}/g, soldout);
//         }else{
//             itemHtml = itemHtml.replace(/{{stockStatus}}/g, instocklabel);
//         }
      /* Boost */
      /* Logic:
          - Only applied if the product vendor is Sonas or Lussaro
          - If the product is in-stock and do not have any variant metafield "custom.back_in_stock_date_from_vendor" => Show "In stock"
          - If the product is in-stock and has at least one variant metafield "custom.back_in_stock_date_from_vendor" => Show "Some variant In Stock"
          - If the product is out-of-stock => Show Out of stock
      */
      const foundVariantMetafield = data.metafields.filter(function(e) {
          return e.namespace == 'custom' && e.key == 'back_in_stock_date_from_vendor' && e?.id;
      })
      
      if (soldOut) {
        
          itemHtml = itemHtml.replace(/{{stockStatus}}/g, soldout);
      // } else if (data.vendor == 'Sonas' || data.vendor == 'Lussaro' || data.vendor == 'Merlyn') {
      // } else if (data.vendor == 'Sonas' || data.vendor == 'XXXXXX') {
      } else if (
            data.vendor == 'Sonas' ||
            (data.vendor == 'Bathroom Outlet' && data.title && data.title.toLowerCase().includes('mirror'))
    ) {
          if (!soldOut && typeof foundVariantMetafield[0] == 'undefined') {
              itemHtml = itemHtml.replace(/{{stockStatus}}/g, instocklabel);
          } else if (!soldOut && typeof foundVariantMetafield[0] !== 'undefined') {
              itemHtml = itemHtml.replace(/{{stockStatus}}/g, someavailable);
          }
          } else {
        // Exclude tile sample variants so their stock status is ignored.
        var consideredVariants = data.variants.filter(function(e) {
            return !isSampleVariant(e);
        });
        // Safety net: if every variant was a sample, fall back to the full list.
        if (consideredVariants.length === 0) consideredVariants = data.variants;

        var inStockVariants = consideredVariants.filter(function(e) {
            return e.available && parseFloat(e.inventory_quantity) > 0;
        })
        if (typeof inStockVariants[0] !== 'undefined') {
            if (inStockVariants.length == consideredVariants.length) {
                itemHtml = itemHtml.replace(/{{stockStatus}}/g, instocklabel);
            } else {
                itemHtml = itemHtml.replace(/{{stockStatus}}/g, someavailable);
            }
        } else {
            var preMap = window.__estimatedDeliveryByHandle;
            var preText = preMap && Object.prototype.hasOwnProperty.call(preMap, data.handle) ? preMap[data.handle] : undefined;
            if (preText) {
                var safeText = String(preText).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
                itemHtml = itemHtml.replace(/{{stockStatus}}/g,
                    '<div class="icon__with__text"><div class="instock__image wd"><img src="https://cdn.shopify.com/s/files/1/0606/2909/0544/files/Estimated_Delivery.svg?v=1748381776"></div><span class="instock__text">' + safeText + '</span></div>');
            } else if (preText === '') {
                itemHtml = itemHtml.replace(/{{stockStatus}}/g, '');
            } else {
                itemHtml = itemHtml.replace(/{{stockStatus}}/g, '<div data-est-delivery-placeholder data-handle="' + data.handle + '"></div>');
            }
        }
    }
      /* Boost */
       
      anyFutureDate = false;
        var dispatchLabelHtml = '';
        const tags_value = data.tags;
        if (tags_value.indexOf('48 hour dispatch') != -1) {
            var dispatchLabelHtml = '<div class="">48 Hour Dispatch</div>';
            itemHtml = itemHtml.replace(/{{dispatchLabel}}/g, dispatchLabelHtml);
            // console.log("data::"+JSON.stringify(data));
        } else {
            itemHtml = itemHtml.replace(/{{dispatchLabel}}/g, dispatchLabelHtml);
        }
        var dispatchLabelHtml2 = ""
        tags_value.forEach(tag => {
            if (tag.toLowerCase().includes('label')) {
                const cleanedTag = tag.replace(/label/i, '').trim();
                dispatchLabelHtml2 += `<div class="">${cleanedTag}</div>`;
                // itemHtml = itemHtml.replace(/{{dispatchLabel2}}/g, dispatchLabelHtml);
            }
        });
        itemHtml = itemHtml.replace(/{{dispatchLabel2}}/g, dispatchLabelHtml2);
        // Add Swatches
        var swatchHtml = buildSwatch(data);
        itemHtml = itemHtml.replace(/{{itemSwatch}}/g, swatchHtml);
        // Add vendor
       
var itemVendorHtml = '';
if (boostPFSConfig.custom.show_vendor && data.vendor !== '') {
  var vendorLower = data.vendor.toLowerCase();
  var vendorLink = boostPFSConfig.shop.url + '/collections/vendors?q=' + Utils.encodeURIParamValue(data.vendor);

  var vendorMap = {
    'aliseo': 'aliseo',
    'aquadomo': 'aquadomo',
    'aquaelite': 'aqua-elite',
    'aqualisa': 'aqualisa',
    'aqualla': 'aqualla',
    'ardex': 'ardex',
    'armitage': 'armitage-shanks',
    'astro': 'astro',
    'axor': 'axor',
    'outlet': 'bathroom-outlet',
    'bal': 'bal',
    'bc designs': 'bc-designs',
    'belvedere': 'belvedere',
    'bette': 'bette',
    'bisque': 'bisque',
    'bossini': 'bossini',
    'britton': 'britton',
    'burlington': 'burlington',
    'cocoon': 'cocoon',
    'crosswater': 'crosswater',
    'dansani': 'dansani',
    'dunlop': 'dunlop',
    'duravit': 'duravit',
    'eastbrook': 'eastbrook',
    'flair': 'flair',
    'flexel': 'flexel',
    'geberit': 'geberit',
    'grohe': 'grohe',
    'grundfos': 'grundfos',
    'hansgrohe': 'hansgrohe',
    'hib': 'hib',
    'imperial': 'imperial',
    'jackoboard': 'jackoboard',
    'just trays': 'just-trays',
    'keuco': 'keuco',
    'laufen': 'laufen',
    'levtec': 'levtec',
    'lithofin': 'lithofin',
    'lucca': 'lucca',
    'lussaro': 'lussaro',
    'marflow': 'marflow',
    'merlyn': 'merlyn',
    'miller': 'miller',
    'mira': 'mira',
    'niko': 'niko',
    'novello': 'novello',
    'solidsoft': 'solidsoft',
    'oli': 'oli',
    'paffoni': 'paffoni',
    'perrin': 'perrin-rowe',
    'quooker': 'quooker',
    'redwing': 'redwing',
    'reina': 'reina',
    'ritmonio': 'ritmonio',
    'roca': 'roca',
    'roman': 'roman',
    'samuel heath': 'samuel-heath',
    'smedbo': 'smedbo',
    'sonas': 'sonas',
    'stilo': 'stilo',
    'tailored': 'tailored-bathrooms',
    'tece': 'tece',
    'triton': 'triton',
    'vado': 'vado',
    'victoria': 'victoria-albert',
    'vogue': 'vogue',
    'wetroom': 'wetroom-materials'
  };

  for (var key in vendorMap) {
    if (vendorLower.includes(key)) {
      vendorLink = 'https://bathroomoutlet.ie/collections/' + vendorMap[key];
      break;
    }
  }

  itemVendorHtml += '<span class="productitem--vendor ' + data.vendor + '"><a href="' + vendorLink + '">' + data.vendor + '</a></span>';
}

      
        itemHtml = itemHtml.replace(/{{itemVendor}}/g, itemVendorHtml);

var priceUnitSuffix = '';

if (Array.isArray(data.metafields)) {
    var unitField = data.metafields.find(function(item) {
        return item.namespace === 'custom' && item.key === 'tile_price_unit';
    });

    if (unitField && unitField.value) {
        priceUnitSuffix = '<span class="tile_price-unit">/' + unitField.value + '</span>';
    }
}

        // Add Price
        var isTileProduct = data.tags && (data.tags.includes('brand-Lucca') || data.tags.includes('Brand-Stilo')); //Used to hide "from" in compare-at price for tile products
        var priceHtml = '';
var classVaries = priceVaries ? 'price--varies' : '';
var visibleClass = onSale || boostPFSConfig.custom.emphasize_price ? 'visible' : '';
priceHtml += '<div class="price productitem__price ' + classVaries + '">';

// Show discounted price first
priceHtml += discounted_Price;

priceHtml += '<div class="hello price__current ';
if (onSale) {
    priceHtml += 'price__current--on-sale ';
}
if (discounted_Price != '')
    priceHtml += 'mrk-old-price-cut-off ';
if (boostPFSConfig.custom.emphasize_price) {
    priceHtml += 'price__current--emphasize ';
}
priceHtml += '" data-price-container>';

var price_html = Utils.formatMoney(data.price_min);

var current_price_range_html = '';
if (priceVaries) {
    if (boostPFSConfig.custom.price_range_format == 'range') {
        if (data__collection == 'tiles__collection' || data.price_min == 0 || data.price_min == '0') {
            current_price_range_html += '<span class="money price__current--min max" data-price-min>' + ' ' + Utils.formatMoney(data.price_max) + '</span>' + priceUnitSuffix;
        } else {
            current_price_range_html += '<span class="money price__current--min" data-price-min>' + ' ' + Utils.formatMoney(data.price_min) + '</span>' + priceUnitSuffix;
        }
    } else {
        if (isTileProduct) {
    current_price_range_html += price_html + priceUnitSuffix;
} else {
    current_price_range_html += boostPFSConfig.label.range_html.replace(/{{ price }}/g, price_html + priceUnitSuffix);
}
    }
}
var current_price_html = '';
if (onSale && boostPFSConfig.custom.show_original) {
    current_price_html += '<span class="visually-hidden">' + boostPFSConfig.label.price_current + '</span>';
}
current_price_html += price_html + priceUnitSuffix;

if (boostPFSConfig.custom.show_range && priceVaries) {
    priceHtml += current_price_range_html;
} else {
    priceHtml += current_price_html;
}
priceHtml += '</div>';

priceHtml += '<div class="price__compare-at ' + visibleClass + '" data-price-compare-container>';
var compare_at_price_html = '<span class="visually-hidden">' + boostPFSConfig.label.price_original + '</span><span class="money price__compare-at--single" data-price-compare>' + Utils.formatMoney(data.compare_at_price_min) + '</span>';
if (onSale) {
    var compare_at_price_range_html = '';
    if (boostPFSConfig.custom.price_range_format == 'default') {
        compare_at_price_range_html = '<span class="visually-hidden">' + boostPFSConfig.label.price_original + '</span>' +
            '<span class="money price__compare-at--min" data-price-compare-min>' + Utils.formatMoney(data.compare_at_price_min) + '</span>' +
            '-' +
            '<span class="visually-hidden">' + boostPFSConfig.label.price_original + '</span>' +
            '<span class="money price__compare-at--min" data-price-compare-max>' + Utils.formatMoney(data.compare_at_price_max) + '</span>';
    } else {
        if (isTileProduct) {
    compare_at_price_range_html = compare_at_price_html;
} else {
    compare_at_price_range_html = boostPFSConfig.label.range_html.replace(/{{ price }}/g, compare_at_price_html);
}
    }
}
if (priceVaries && onSale && boostPFSConfig.custom.show_original && boostPFSConfig.custom.show_range) {
    priceHtml += compare_at_price_range_html;
} else if (onSale && boostPFSConfig.custom.show_original) {
    priceHtml += compare_at_price_html;
} else if (boostPFSConfig.custom.emphasize_price && boostPFSConfig.custom.include_spacer) {
    priceHtml += '<span class="price__spacer"></span>';
} else if (boostPFSConfig.custom.show_original) {
    priceHtml += '<span class="money price__original" data-price-original></span>';
}
priceHtml += '</div>';

if (boostPFSConfig.custom.include_hidden_price) {
    priceHtml += '<div class="price__compare-at--hidden" data-compare-price-range-hidden>';
    if (boostPFSConfig.custom.price_range_format == 'range') {
        priceHtml += '<span class="visually-hidden">' + boostPFSConfig.label.price_original + '</span>' +
            '<span class="money price__compare-at--min" data-price-compare-min>' + Utils.formatMoney(data.compare_at_price_min) + '</span>' +
            '-' +
            '<span class="visually-hidden">' + boostPFSConfig.label.price_original + '</span>' +
            '<span class="money price__compare-at--min" data-price-compare-max>' + Utils.formatMoney(data.compare_at_price_max) + '</span>';
    } else {
        priceHtml += boostPFSConfig.label.range_html.replace(/{{ price }}/g, compare_at_price_html);
    }
    priceHtml += '</div>';
}
if (boostPFSConfig.custom.include_unit_price) {
    var total_quantity = '<span class="productitem__total-quantity" data-total-quantity>' + firstVariant.unit_price_measurement.quantity_value + firstVariant.unit_price_measurement.quantity_unit + '</span>';
    var unit_price = '<span class="productitem__unit-price--amount money" data-unit-price-amount>' + Utils.formatMoney(firstVariant.price) + '</span>';
    var unit_measure = '<span class="productitem__unit-price--measure" data-unit-price-measure>';
    if (firstVariant.unit_price_measurement.reference_value !== 1) {
        unit_measure += firstVariant.unit_price_measurement.reference_value;
    } else {
        unit_measure += firstVariant.unit_price_measurement.reference_unit;
    }
    unit_measure += '</span>';
    priceHtml += '<div class="productitem__unit-price ';
    if (!firstVariant.unit_price_measurement) {
        priceHtml += 'hidden';
    }
    priceHtml += '">';
    priceHtml += boostPFSConfig.label.price_per_unit_html.replace(/{{ total_quantity }}/g, total_quantity).replace(/{{ unit_price }}/g, unit_price).replace(/{{ unit_measure }}/g, unit_measure);
    priceHtml += '</div>';
}
priceHtml += '</div>';
priceHtml += discounted_tag;

        // Tile product: replace price display with tile_size_card value + calculated Was price
        // Tile product: replace price display with tile_size_card value + calculated Was price
        if (isTileProduct) {
            var tileM2Field = Array.isArray(data.metafields) && data.metafields.find(function(item) {
                return item.namespace === 'custom' && item.key === 'tile_m2_sale_price';
            });
            var tileM2Amount = '';
            if (tileM2Field && tileM2Field.value) {
                if (typeof tileM2Field.value === 'string') {
                    try { tileM2Amount = JSON.parse(tileM2Field.value).amount || tileM2Field.value; }
                    catch (e) { tileM2Amount = tileM2Field.value; }
                } else if (tileM2Field.value.amount) {
                    tileM2Amount = tileM2Field.value.amount;
                }
            }

            if (tileM2Amount) {
                var tileM2Num = parseFloat(tileM2Amount);
                var tradeMultiplier = (window.mrkTradeCustomer && window.mrkTradeMultiplier) ? window.mrkTradeMultiplier : 1;
                var displayM2Num = tileM2Num * tradeMultiplier;
                var tileWasNum = tileM2Num / 0.8;

                priceHtml = '<div class="price productitem--tile-m2-price productitem--sale">';
                priceHtml += '<div class="price__current price__current--on-sale price__current--emphasize">';
                priceHtml += '<span class="money price__current--min">€' + displayM2Num.toFixed(2) + '/m²</span>';
                priceHtml += '</div>';
                priceHtml += '<div class="price__compare-at visible">';
                priceHtml += '<span class="visually-hidden">Was </span>';
                priceHtml += '<span class="money price__compare-at--single">€' + tileWasNum.toFixed(2) + '</span>';
                priceHtml += '</div>';
                priceHtml += '</div>';
            }
        }

        // Add emphasize price
        var emphasizePriceHtml = '';
        var noEmphasizePriceHtml = '';
        if (boostPFSConfig.custom.emphasize_price) {
            emphasizePriceHtml += priceHtml;
        } else {
            noEmphasizePriceHtml += priceHtml;
        }
        itemHtml = itemHtml.replace(/{{emphasizePrice}}/g, emphasizePriceHtml);
        itemHtml = itemHtml.replace(/{{noEmphasizePrice}}/g, noEmphasizePriceHtml);
        // Add Reviews
        if (typeof Integration === 'undefined' || !Integration.hascompileTemplate('reviews')) {
            var itemReviewsHtml = '';
            if (boostPFSConfig.custom.product_ratings_reviews && boostPFSConfig.custom.product_ratings_star_display == 'all') {
                itemReviewsHtml += '<div class="productitem--ratings">' +
                    '<span class="shopify-product-reviews-badge" data-id="{{itemId}}">' +
                    '<span class="spr-badge">' +
                    '<span class="spr-starrating spr-badge-starrating">' +
                    '<i class="spr-icon spr-icon-star-empty"></i>' +
                    '<i class="spr-icon spr-icon-star-empty"></i>' +
                    '<i class="spr-icon spr-icon-star-empty"></i>' +
                    '<i class="spr-icon spr-icon-star-empty"></i>' +
                    '<i class="spr-icon spr-icon-star-empty"></i>' +
                    '</span>' +
                    '</span>' +
                    '</span>' +
                    '</div>';
            }
            itemHtml = itemHtml.replace(/{{itemReviews}}/g, itemReviewsHtml);
        }
        // Add description
        var itemDescriptionHtml = jQ('<div></div>').html(data.body_html).text(); // Strips html tags
        itemDescriptionHtml = '<div class="productitem--description">' + itemDescriptionHtml + '</div>';
        itemHtml = itemHtml.replace(/{{itemDescription}}/g, itemDescriptionHtml);

/* === Multiple Options Available (variants > 1) === */
var multiOptionText = '';
var isTileProductForOptions = Array.isArray(data.metafields) && data.metafields.find(function(item) {
  return item.namespace === 'custom' && item.key === 'tile_size_card' && item.value;
});

if (data.variants && data.variants.length > 1 && !isTileProductForOptions) {
  multiOptionText = '<div class="productitem--multi-options">More Options Available</div>';
}

itemHtml = itemHtml.replace(/{{multiOptionText}}/g, multiOptionText);
/* === end Multiple Options Available === */

        // Add main attribute (Always put at the end of this function)
        // Store m2 per box in a hidden element for trade price conversion
        
        itemHtml = itemHtml.replace(/{{itemId}}/g, data.id);
        itemHtml = itemHtml.replace(/{{itemVariantId}}/g, data.variants[0].id);
        itemHtml = itemHtml.replace(/{{itemHandle}}/g, data.handle);
        itemHtml = itemHtml.replace(/{{itemTitle}}/g, data.title);
        itemHtml = itemHtml.replace(/{{itemUrl}}/g, Utils.buildProductItemUrl(data));
        itemHtml = itemHtml.replace(/{{itemVariantId}}/g, data.variants[0].id);
        itemHtml = itemHtml.replace(/{{itemHandle}}/g, data.handle);
        itemHtml = itemHtml.replace(/{{itemTitle}}/g, data.title);
        itemHtml = itemHtml.replace(/{{itemUrl}}/g, Utils.buildProductItemUrl(data));
        var itemQuickShopSettings = '';
        if (boostPFSConfig.custom.atc_display !== 'disabled') {
            itemQuickShopSettings += '<script type="application/json" data-quick-buy-settings>';
            itemQuickShopSettings += '{';
            itemQuickShopSettings += '"cart_redirection": ' + boostPFSConfig.custom.cart_redirect + ','
            itemQuickShopSettings += '"money_format": "' + boostPFSConfig.custom.money_format + '"'
            itemQuickShopSettings += '}'
            itemQuickShopSettings += '</script>';
        }
        itemHtml = itemHtml.replace(/{{itemQuickShopSettings}}/g, itemQuickShopSettings);
        var itemDataSha256 = sha256(JSON.stringify(data.id));
        itemHtml = itemHtml.replace(/{{itemDataSha256}}/g, itemDataSha256);
        if (typeof Utils.compileShopifyProductVariables == 'function') {
            itemHtml = Utils.compileShopifyProductVariables(data, itemHtml);
        }
        if (typeof Utils.compileShopifyProductMetafield == 'function') {
            itemHtml = Utils.compileShopifyProductMetafield(data, itemHtml);
        }
       

var tileM2SalePriceHtml = '';

if (Array.isArray(data.metafields)) {
  var tileSalePriceMetafield = data.metafields.find(function(item) {
    return item.namespace === 'custom' && item.key === 'tile_m2_sale_price';
  });

  if (tileSalePriceMetafield && tileSalePriceMetafield.value) {
    var amount = '';

    if (typeof tileSalePriceMetafield.value === 'string') {
      try {
        var parsed = JSON.parse(tileSalePriceMetafield.value);
        amount = parsed.amount || '';
      } catch (e) {
        amount = tileSalePriceMetafield.value;
      }
    } else if (tileSalePriceMetafield.value.amount) {
      amount = tileSalePriceMetafield.value.amount;
    }

  /*  if (amount) {
      tileM2SalePriceHtml = '<div class="tile-m2-price">€' + parseFloat(amount).toFixed(2) + '/m²</div>';
    } */
  }
}

itemHtml = itemHtml.replace(/{{tileM2SalePrice}}/g, tileM2SalePriceHtml);

var tileSizeCardHtml = '';

if (Array.isArray(data.metafields)) {
  var tileSizeCardMetafield = data.metafields.find(function(item) {
    return item.namespace === 'custom' && item.key === 'tile_size_card';
  });

  if (tileSizeCardMetafield && tileSizeCardMetafield.value) {
    tileSizeCardHtml = '<span class="productitem--tile-size-card">' + tileSizeCardMetafield.value + '</span>';
  }
}

itemHtml = itemHtml.replace(/{{tileSizeCard}}/g, tileSizeCardHtml);

var priceUnitHtml = '';

if (Array.isArray(data.metafields)) {
  var unitField = data.metafields.find(function(item) {
    return item.namespace === 'custom' && item.key === 'tile_price_unit';
  });

  if (unitField && unitField.value) {
    var unit = unitField.value;

    priceUnitHtml = '<span class="tile_price-unit"> /' + unit + '</span>';
  }
}

itemHtml = itemHtml.replace(/{{priceUnit}}/g, priceUnitHtml);
/* === Trustpilot Product Mini Reviews === */
var trustpilotMiniReviewsHtml = '';

if (data.tags && data.tags.indexOf('trustpilot-reviews') !== -1) {
  var tpSku = '';

  if (data.variants && data.variants.length) {
    var tpSkuList = [];
    data.variants.forEach(function(variant) {
      if (!variant.sku) return;
      var s = String(variant.sku).trim();
      if (!s) return;
      if (s.toUpperCase().indexOf('SAMP-') === 0) return;                  // skip tile samples
      if (String(variant.is_sample_varaint).toLowerCase() === 'true') return;
      if (tpSkuList.indexOf(s) === -1) tpSkuList.push(s);                  // all variant SKUs
    });
    tpSku = tpSkuList.join(',');
  }

  if (!tpSku && data.id) {
    tpSku = data.id;
  }

  if (tpSku) {
    trustpilotMiniReviewsHtml =
  '<div class="trustpilot-card-mini">' +
    '<div class="trustpilot-widget" ' +
      'data-locale="en-IE" ' +
      'data-template-id="577258fb31f02306e4e3aaf9" ' +
      'data-businessunit-id="64490bb9b854791c4f719fd6" ' +
      'data-style-height="24px" ' +
      'data-style-width="100%" ' +
      'data-sku="' + tpSku + '" ' +
      'data-no-reviews="hide" ' +
      'data-scroll-to-list="false" ' +
      'data-style-alignment="left" ' +
      'data-text-color="#1d1d1d">' +
      '<a href="https://ie.trustpilot.com/review/bathroomoutlet.ie" target="_blank" rel="noopener">Trustpilot</a>' +
    '</div>' +
    '<a class="trustpilot-card-overlay-link" href="' + Utils.buildProductItemUrl(data) + '" aria-label="View ' + data.title.replace(/"/g, '&quot;') + '"></a>' +
  '</div>';
  }
}

itemHtml = itemHtml.replace(/{{trustpilotMiniReviews}}/g, trustpilotMiniReviewsHtml);
/* === End Trustpilot Product Mini Reviews === */
        return itemHtml;
    };
    //   var orgProductGridItemcompileTemplateFn = ProductGridItem.prototype.compileTemplate;
    //   ProductListItem.prototype.compileTemplate = function(data, index, totalProduct){
    //     return orgProductGridItemcompileTemplateFn.call(this, data, index, totalProduct);
    //   }
    function buildImage(imageInfo, size, className) {
        if (!imageInfo) {
            imageInfo = {
                src: boostPFSConfig.general.no_image_url,
                width: 480,
                height: 480,
                aspect_ratio: 1
            }
        }
        var width = size.split('x')[0];
        var height = 0;
        if (!imageInfo && imageInfo.aspect_ratio) {
            height = width * imageInfo.aspect_ratio;
        } else {
            height = 512;
        }
        var srcset = "data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='X' height='Y'></svg>";
        srcset = srcset.replace('X', width).replace('Y', height).replace(/ /g, '%20');
        var html = '<img ' +
            'src="' + Utils.optimizeImage(imageInfo.src, size) + '" ' +
            'class="' + className + '" ' +
            'alt="{{itemTitle}}" ' +
            'data-rimg="lazy" ' +
            'data-rimg-scale="1" ' +
            'data-rimg-template="' + Utils.optimizeImage(imageInfo.src, '{size}') + '" ' +
            'data-rimg-max="' + imageInfo.width + 'x' + imageInfo.height + '" ' +
            'data-rimg-crop ' +
            '>';
        html += '<div data-rimg-canvas></div>';
        return html;
    }

    function buildActions(data, firstVariant) {
        var actionsHtml = '';
        var has_variants = firstVariant['option_title'] == 'Default Title' ? false : true;
        if (boostPFSConfig.custom.atc_display !== 'disabled' || boostPFSConfig.custom.quick_shop_display !== 'disabled') {
            var quick_look_text = boostPFSConfig.label.quick_look_text;
            var quick_buy_text = boostPFSConfig.label.quick_buy_text;
            var quick_look_classes = 'productitem--action-trigger button-secondary';
            var quick_buy_classes = 'productitem--action-trigger productitem--action-atc button-primary';
            if (has_variants) {
                quick_buy_text = boostPFSConfig.label.quick_choose_options;
            }
            if (!data.available) {
                quick_buy_text = boostPFSConfig.label.sold_out;
                quick_buy_classes = quick_buy_classes + ' disabled';
            }
            actionsHtml += '<div class="productitem--actions" data-product-actions>';
            if (boostPFSConfig.custom.grid_list) {
                actionsHtml += '<div class="productitem--listview-price">{{noEmphasizePrice}}</div>';
                actionsHtml += '<div class="productitem--listview-badge">{{itemLabels}}</div>';
            }
            if (boostPFSConfig.custom.quick_shop_display !== 'disabled') {
                actionsHtml += '<div class="productitem--action quickshop-button ';
                if (boostPFSConfig.custom.quick_shop_display == 'desktop') actionsHtml += 'productitem-action--desktop';
                actionsHtml += '">' +
                    '<button class="' + quick_look_classes + '" data-quickshop-full ';
                if (boostPFSConfig.custom.gallery_thumbnail_position == 'left') actionsHtml += 'data-thumbs-left';
                actionsHtml += ' data-id="{{itemId}}" type="button" tabindex="1">' +
                    quick_look_text +
                    '</button>' + '</div>';
            }
            if (boostPFSConfig.custom.atc_display !== 'disabled') {
                if (!has_variants) {
                    var temp = ' data-quick-buy ';
                } else {
                    var temp = ' data-quickshop-slim ';
                }
                actionsHtml += '<div class="productitem--action atc--button ';
                if (boostPFSConfig.custom.atc_display == 'desktop') actionsHtml += 'productitem-action--desktop';
                actionsHtml += '">' +
                    '<button class="' + quick_buy_classes + '" tabindex="1" type="button" aria-label="' + quick_buy_text + '"' +
                    temp + 'data-variant-id="' + data.variants[0].id + '"';
                if (!data.available) {
                    actionsHtml += ' disabled';
                }
                actionsHtml += '>';
                actionsHtml += '<span class="atc-button--text">' + quick_buy_text + '</span>';
                actionsHtml += '<span class="atc-button--icon">';
                actionsHtml += '<svg aria-hidden="true" focusable="false" role="presentation" width="26" height="26" viewBox="0 0 26 26" xmlns="http://www.w3.org/2000/svg" > <g fill-rule="nonzero" fill="currentColor"> <path d="M13 26C5.82 26 0 20.18 0 13S5.82 0 13 0s13 5.82 13 13-5.82 13-13 13zm0-3.852a9.148 9.148 0 1 0 0-18.296 9.148 9.148 0 0 0 0 18.296z" opacity=".29"/><path d="M13 26c7.18 0 13-5.82 13-13a1.926 1.926 0 0 0-3.852 0A9.148 9.148 0 0 1 13 22.148 1.926 1.926 0 0 0 13 26z"/> </g> </svg>';
                actionsHtml += '</span>';
                actionsHtml += '</button>';
                actionsHtml += '</div>';
            }
            actionsHtml += '</div>' + '<span class="smartwishlist" data-product="{{itemId}}" data-variant="' + data.variants[0].id + '"></span>';
        }
        return actionsHtml;
    }

    function buildSwatch(data) {
        var html = '';
        var swatches = [];
        var swatchValues = [];
        var swatchOptionIndex = 1;
        if (boostPFSConfig.custom.swatches_enable && boostPFSConfig.custom.swatch_trigger) {
            var customColors = boostPFSConfig.custom.swatches_custom_colors.split('\n');
            data.variants.forEach(function(variant) {
                var swatchValue = '';
                variant.options = variant.merged_options; // Use for theme function
                variant.merged_options.forEach(function(merged_option, index) {
                    var key = merged_option.split(':')[0].trim();
                    var value = merged_option.split(':')[1].trim();
                    if (key.toLowerCase() == boostPFSConfig.custom.swatch_trigger && swatchValues.indexOf(value.toLowerCase()) == -1) {
                        swatchValue = value;
                        swatchValues.push(value.toLowerCase());
                        swatchOptionIndex = index + 1;
                    }
                })
                if (swatchValue) {
                    var swatch = '<label>' +
                        '<input class="productitem--swatches-input" type="radio" tabindex="0" name="swatch" value="{{swatchValue}}" data-product-id="{{itemId}}" data-variant-image="{{variantImage}}">' +
                        '<div class="productitem--swatches-swatch-wrapper" data-swatch-tooltip="{{swatchValue}}" data-swatch>' +
                        '<div class="productitem--swatches-swatch">' +
                        '<div class="productitem--swatches-swatch-inner" ' +
                        'style="background-color:{{backgroundColor}}; background-color:{{customColor}}; background-image:url({{backgroundImage}}); background-size:cover"></div>' +
                        '</div>' +
                        '</div>' +
                        '</label>';
                    var customColor = '';
                    customColors.forEach(function(color) {
                        if (color.split(':').length == 2) {
                            var customColorName = color.split(':')[0].trim().toLowerCase();
                            var customColorValue = color.split(':')[1].trim().toLowerCase();
                            if (customColorName == swatchValue.toLowerCase()) {
                                customColor = customColorValue;
                            }
                        }
                    })
                    var slugifyValue = Utils.slugify(swatchValue);
                    var backgroundColor = slugifyValue.split('-').pop();
                    var backgroundImage = '';
                    var variantImage = '';
                    if (boostPFSConfig.custom.swatches_option_style == "variant_image" && variant.image) {
                        backgroundImage = Utils.optimizeImage(variant.image, '50x');
                        variantImage = Utils.optimizeImage(variant.image, '512x');
                    } else {
                        backgroundImage = boostPFSAppConfig.general.file_url.split('?')[0] + slugifyValue + '.png';
                        variantImage = boostPFSAppConfig.general.no_image_url;
                    }
                    swatch = swatch.replace(/{{swatchValue}}/g, swatchValue);
                    swatch = swatch.replace(/{{backgroundColor}}/g, backgroundColor);
                    swatch = swatch.replace(/{{backgroundImage}}/g, backgroundImage);
                    swatch = swatch.replace(/{{variantImage}}/g, variantImage);
                    swatch = swatch.replace(/{{customColor}}/g, customColor);
                    swatches.push(swatch);
                }
            })
            if (swatchValues.length > 0) {
                var html = '<div class="productitem--swatches {{swatchClass}}" data-swatches>' +
                    '<script type="application/json" data-swatch-data>' +
                    '{' +
                    '"hash": "{{itemDataSha256}}",' +
                    '"swatchOptionKey": "{{swatchOptionKey}}",' +
                    '"variants": {{variantsJson}}' +
                    '}' +
                    '</script>' +
                    '<form class="productitem--swatches-container" data-swatches-container>' +
                    swatches.join(' ') +
                    '</form>' +
                    '<button class="productitem--swatches-count-wrapper" data-swatch-count-wrapper>' +
                    '<div class="productitem--swatches-count" data-swatch-count>+</div>' +
                    '</button>' +
                    '</div>';
                var swatchClass = boostPFSConfig.custom.swatches_shape == 'square' &&
                    boostPFSConfig.custom.swatches_option_style == 'variant_image' ?
                    'swatches-variant-images-square' : '';
                html = html.replace(/{{swatchClass}}/g, swatchClass);
                html = html.replace(/{{swatchOptionKey}}/g, 'option' + swatchOptionIndex);
                html = html.replace(/{{variantsJson}}/g, JSON.stringify(data.variants));
            }
        }
        return html;
    }
    /************************** END BUILD PRODUCT LIST **************************/
    // Build Pagination
    ProductPaginationDefault.prototype.compileTemplate = function(totalProduct) {
        if (!totalProduct) totalProduct = this.totalProduct;
        // Get page info
        var currentPage = parseInt(Globals.queryParams.page);
        var totalPage = Math.ceil(totalProduct / Globals.queryParams.limit);
        if (totalPage > 1) {
            var paginationHtml = boostPFSTemplate.paginateHtml;
            // Build Previous
            var previousHtml = (currentPage > 1) ? boostPFSTemplate.previousActiveHtml : boostPFSTemplate.previousDisabledHtml;
            previousHtml = previousHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, currentPage - 1));
            paginationHtml = paginationHtml.replace(/{{previous}}/g, previousHtml);
            // Build Next
            var nextHtml = (currentPage < totalPage) ? boostPFSTemplate.nextActiveHtml : boostPFSTemplate.nextDisabledHtml;
            nextHtml = nextHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, currentPage + 1));
            paginationHtml = paginationHtml.replace(/{{next}}/g, nextHtml);
            // Create page items array
            var beforeCurrentPageArr = [];
            for (var iBefore = currentPage - 1; iBefore > currentPage - 3 && iBefore > 0; iBefore--) {
                beforeCurrentPageArr.unshift(iBefore);
            }
            if (currentPage - 4 > 0) {
                beforeCurrentPageArr.unshift('...');
            }
            if (currentPage - 4 >= 0) {
                beforeCurrentPageArr.unshift(1);
            }
            beforeCurrentPageArr.push(currentPage);
            var afterCurrentPageArr = [];
            for (var iAfter = currentPage + 1; iAfter < currentPage + 3 && iAfter <= totalPage; iAfter++) {
                afterCurrentPageArr.push(iAfter);
            }
            if (currentPage + 3 < totalPage) {
                afterCurrentPageArr.push('...');
            }
            if (currentPage + 3 <= totalPage) {
                afterCurrentPageArr.push(totalPage);
            }
            // Build page items
            var pageItemsHtml = '';
            var pageArr = beforeCurrentPageArr.concat(afterCurrentPageArr);
            for (var iPage = 0; iPage < pageArr.length; iPage++) {
                if (pageArr[iPage] == '...') {
                    pageItemsHtml += boostPFSTemplate.pageItemRemainHtml;
                } else {
                    pageItemsHtml += (pageArr[iPage] == currentPage) ? boostPFSTemplate.pageItemSelectedHtml : boostPFSTemplate.pageItemHtml;
                }
                pageItemsHtml = pageItemsHtml.replace(/{{itemTitle}}/g, pageArr[iPage]);
                pageItemsHtml = pageItemsHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, pageArr[iPage]));
            }
            paginationHtml = paginationHtml.replace(/{{pageItems}}/g, pageItemsHtml);
            return paginationHtml;
        }
        return '';
    };
    /************************** BUILD TOOLBAR **************************/
    // Build Sorting
    ProductSorting.prototype.compileTemplate = function() {
        if (boostPFSTemplate.hasOwnProperty('sortingHtml')) {
            var sortingArr = Utils.getSortingList();
            if (sortingArr) {
                // Build content
                var sortingItemsHtml = '';
                for (var k in sortingArr) {
                    sortingItemsHtml += '<option value="' + k + '">' + sortingArr[k] + '</option>';
                }
                var html = boostPFSTemplate.sortingHtml.replace(/{{sortingItems}}/g, sortingItemsHtml);
                return html;
            }
            return '';
        }
    };
    // Build Show Limit
    ProductLimit.prototype.compileTemplate = function() {
        if (boostPFSTemplate.hasOwnProperty('showLimitHtml')) {
            var numberList = Settings.getSettingValue('general.showLimitList');
            if (numberList != '') {
                // Build content
                var showLimitItemsHtml = '';
                var arr = numberList.split(',');
                for (var k = 0; k < arr.length; k++) {
                    if (arr[k] == Globals.queryParams.limit) {
                        showLimitItemsHtml += '<li><a class="utils-showby-item active" href="' + arr[k] + '">' + arr[k] + '</a></li>';
                    } else {
                        showLimitItemsHtml += '<li><a class="utils-showby-item" href="' + arr[k] + '">' + arr[k] + '</a></li>';
                    }
                }
                var html = boostPFSTemplate.showLimitHtml.replace(/{{showLimitItems}}/g, showLimitItemsHtml);
                return html;
            }
        }
        return '';
    };
    ProductLimit.prototype.bindEvents = function() {
        var _this = this;
        jQ(Selector.topShowLimit + ' li a').on("click", function(e) {
            event.preventDefault();
            Globals.internalClick = true;
            FilterApi.setParam('limit', jQ(this).attr('href'));
            FilterApi.applyFilter();

            // Samita
            setTimeout(function() {
                if (typeof Samita !== "undefined" && typeof Samita.ProductLabels !== "undefined") {       Samita.ProductLabels.init();  }
            }, 1000);
        })
    };
    // Build Breadcrumb
    Breadcrumb.prototype.compileTemplate = function(colData, apiData) {
        if (!colData) colData = this.collectionData;
        if (typeof colData !== 'undefined' && colData.hasOwnProperty('collection')) {
            var colInfo = colData.collection;
            var delimiter = '<span class="breadcrumbs-delimiter" aria-hidden="true"><svg aria-hidden="true" focusable="false" role="presentation" xmlns="http://www.w3.org/2000/svg" width="8" height="5" viewBox="0 0 8 5"><path fill="currentColor" fill-rule="evenodd" d="M1.002.27L.29.982l3.712 3.712L7.714.982 7.002.27l-3 3z"/></svg></span>';
            var breadcrumbHtml = '<a href="/">' + boostPFSConfig.label.breadcrumb_home + '</a> ';
            breadcrumbHtml += delimiter;
            breadcrumbHtml += ' <span>' + colInfo.title + '</span>';
            return breadcrumbHtml;
        }
        return '';
    };
    /************************** END BUILD TOOLBAR **************************/
    // Add additional feature for product list, used commonly in customizing product list
    ProductList.prototype.afterRender = function(data, eventType) {
        if (eventType != 'init' && typeof ReloadSmartWishlist !== 'undefined') {
            ReloadSmartWishlist();
        }
        // if (jQ(Selector.products + ' [data-rimg="lazy"]').length > 0) {
        //   jQ(Selector.products + ' [data-rimg="lazy"]').attr('data-rimg', 'loaded');
        // }
    };
    // Build additional elements
    FilterResult.prototype.afterRender = function(data, eventType) {
        if (!data) data = this.data;
        /**
        In empire.js.liquid:
        - Add "var bcInitEmpire;" to the begining
        - Go to the end, add "bcInitEmpire = Empire_initEmpire;" before the 2 brackets close:

             (some codes here...)
             bcInitEmpire = Empire_initEmpire;
             })
             });
             (end of file)
        */
        if (window.bcInitEmpire && typeof bcInitEmpire == 'function') {
            // Don't reinit the recently viewed block
            if (jQ('[data-section-type="static-recently-viewed"]').length > 0) {
                jQ('[data-section-type="static-recently-viewed"]').attr('data-section-type', 'bc-static-recently-viewed');
            }
            // Don't reinit the header
            if (jQ('[data-section-type="static-header"]').length > 0) {
                jQ('[data-section-type="static-header"]').attr('data-section-type', 'bc-static-header');
            }
            // Reinit theme
            bcInitEmpire();
            if (jQ('[data-section-type="bc-static-recently-viewed"]').length > 0) {
                jQ('[data-section-type="bc-static-recently-viewed"]').attr('data-section-type', 'static-recently-viewed');
            }
            if (jQ('[data-section-type="bc-static-header"]').length > 0) {
                jQ('[data-section-type="bc-static-header"]').attr('data-section-type', 'static-header');
            }
        }
        jQ('.productitem--swatches-input').on('click', function(e) {
            const target = e.target;
            const variantImage = target.getAttribute('data-variant-image');
            const prodId = target.getAttribute('data-product-id');
            const prodElm = document.querySelector('.productgrid--item[data-id="' + prodId + '"]');
            if (prodElm) {
                const imageElms = prodElm.querySelectorAll('.productitem--image img');
                if (imageElms) {
                    imageElms.forEach(function(el) {
                        el.src = variantImage
                    });
                }
            }
        })
        const productElms = document.querySelectorAll('.productgrid--item');
        if (productElms) {
            productElms.forEach(function(el) {
                const swatchContainer = el.querySelector('.productitem--swatches-container');
                if (swatchContainer) {
                    const swatchElms = swatchContainer.querySelectorAll('label');
                    if (swatchElms && swatchElms.length > 4) {
                        let cumulativeWidth = 0;
                        for (let i = 0; i < swatchElms.length; i++) {
                            let swatch = swatchElms[i];
                            if (cumulativeWidth + swatch.getBoundingClientRect().width < swatchContainer.getBoundingClientRect().width - 48) {
                                cumulativeWidth += swatch.getBoundingClientRect().width;
                            } else {
                                break;
                            }
                        }
                        el.querySelector('.productitem--swatches-count-wrapper').style.left = cumulativeWidth + 'px';
                        el.querySelector('.productitem--swatches-count-wrapper').style.display = 'flex';
                                                el.querySelector('.productitem--swatches-count-wrapper .productitem--swatches-count').innerText = '+' + (swatchElms.length - 4);
                    }
                }
            });

            // Load Trustpilot widgets ONCE for the freshly rendered cards.
            // (Previously this ran inside the per-card loop, so with N cards it
            //  force-reloaded every widget N times — N×N reloads — which is what
            //  made them appear seconds late.)
            (function () {
                function loadNow() {
                    if (!window.Trustpilot) return false;
                    document.querySelectorAll('.trustpilot-card-mini .trustpilot-widget').forEach(function (widget) {
                        if (widget.getAttribute('data-tp-loaded')) return; // already loaded — skip
                        window.Trustpilot.loadFromElement(widget, true);
                        widget.setAttribute('data-tp-loaded', '1');
                    });
                    return true;
                }
                // Load immediately if the bootstrap script is ready…
                if (loadNow()) return;
                // …otherwise poll briefly until window.Trustpilot exists.
                var tries = 0;
                var timer = setInterval(function () {
                    if (loadNow() || ++tries > 50) clearInterval(timer);
                }, 100);
            })();
        }
    };
    // sha256 of a string and display its hex digest
    function sha256(ascii) {
        function rightRotate(value, amount) {
            return (value >>> amount) | (value << (32 - amount));
        };
        var mathPow = Math.pow;
        var maxWord = mathPow(2, 32);
        var lengthProperty = 'length'
        var i, j; // Used as a counter across the whole file
        var result = ''
        var words = [];
        var asciiBitLength = ascii[lengthProperty] * 8;
        //* caching results is optional - remove/add slash from front of this line to toggle
        // Initial hash value: first 32 bits of the fractional parts of the square roots of the first 8 primes
        // (we actually calculate the first 64, but extra values are just ignored)
        var hash = sha256.h = sha256.h || [];
        // Round constants: first 32 bits of the fractional parts of the cube roots of the first 64 primes
        var k = sha256.k = sha256.k || [];
        var primeCounter = k[lengthProperty];
        /*/
        var hash = [], k = [];
        var primeCounter = 0;
        //*/
        var isComposite = {};
        for (var candidate = 2; primeCounter < 64; candidate++) {
            if (!isComposite[candidate]) {
                for (i = 0; i < 313; i += candidate) {
                    isComposite[i] = candidate;
                }
                hash[primeCounter] = (mathPow(candidate, .5) * maxWord) | 0;
                k[primeCounter++] = (mathPow(candidate, 1 / 3) * maxWord) | 0;
            }
        }
        ascii += '\x80' // Append Ƈ' bit (plus zero padding)
        while (ascii[lengthProperty] % 64 - 56) ascii += '\x00' // More zero padding
        for (i = 0; i < ascii[lengthProperty]; i++) {
            j = ascii.charCodeAt(i);
            if (j >> 8) return; // ASCII check: only accept characters in range 0-255
            words[i >> 2] |= j << ((3 - i) % 4) * 8;
        }
        words[words[lengthProperty]] = ((asciiBitLength / maxWord) | 0);
        words[words[lengthProperty]] = (asciiBitLength)
        // process each chunk
        for (j = 0; j < words[lengthProperty];) {
            var w = words.slice(j, j += 16); // The message is expanded into 64 words as part of the iteration
            var oldHash = hash;
            // This is now the undefinedworking hash", often labelled as variables a...g
            // (we have to truncate as well, otherwise extra entries at the end accumulate
            hash = hash.slice(0, 8);
            for (i = 0; i < 64; i++) {
                var i2 = i + j;
                // Expand the message into 64 words
                // Used below if
                var w15 = w[i - 15],
                    w2 = w[i - 2];
                // Iterate
                var a = hash[0],
                    e = hash[4];
                var temp1 = hash[7] +
                    (rightRotate(e, 6) ^ rightRotate(e, 11) ^ rightRotate(e, 25)) // S1
                    +
                    ((e & hash[5]) ^ ((~e) & hash[6])) // ch
                    +
                    k[i]
                    // Expand the message schedule if needed
                    +
                    (w[i] = (i < 16) ? w[i] : (
                        w[i - 16] +
                        (rightRotate(w15, 7) ^ rightRotate(w15, 18) ^ (w15 >>> 3)) // s0
                        +
                        w[i - 7] +
                        (rightRotate(w2, 17) ^ rightRotate(w2, 19) ^ (w2 >>> 10)) // s1
                    ) | 0);
                // This is only used once, so *could* be moved below, but it only saves 4 bytes and makes things unreadble
                var temp2 = (rightRotate(a, 2) ^ rightRotate(a, 13) ^ rightRotate(a, 22)) // S0
                    +
                    ((a & hash[1]) ^ (a & hash[2]) ^ (hash[1] & hash[2])); // maj
                hash = [(temp1 + temp2) | 0].concat(hash); // We don't bother trimming off the extra ones, they're harmless as long as we're truncating when we do the slice()
                hash[4] = (hash[4] + temp1) | 0;
            }
            for (i = 0; i < 8; i++) {
                hash[i] = (hash[i] + oldHash[i]) | 0;
            }
        }
        for (i = 0; i < 8; i++) {
            for (j = 3; j + 1; j--) {
                var b = (hash[i] >> (j * 8)) & 255;
                result += ((b < 16) ? 0 : '') + b.toString(16);
            }
        }
        return result;
    };
    ProductPaginationDefault.prototype._onClickEvent = function(event) {
        event.preventDefault();
        Globals.internalClick = true;
        // Get the new page value
        var url;
        try {
            url = new URL(jQ(event.currentTarget).attr('href'));
        } catch (e) {
            url = new URL('https://' + boostPFSConfig.shop.domain + jQ(event.currentTarget).attr('href'));
        }
        var pageValue = url && url.searchParams ? url.searchParams.get('page') : 1;
        if (!pageValue || isNaN(pageValue)) pageValue = 1;
        // Apply filter
        FilterApi.setParam('page', pageValue);
        FilterApi.applyFilter('page');
        // Scroll to top of product list
        window.scrollTo({
            top: Utils.isMobile() ? this.$productList.offset().top - 50 : 0,
            behavior: 'smooth'
        });
    }

  ProductSliderItem.prototype.bindEvents = function() {
		if (this.$element && this.parent.$element) {
			var width = this.parent.$element.width() / this.parent.productSliderRange;
            if (window.innerWidth > 859) {
    			width = (this.parent.$element.width() - 210) / this.parent.productSliderRange;
                jQ('.search--section .layout--has-sidebar .productgrid--wrapper').css({
                  display: 'block',
                  width: '100%'
                })
            }
			this.$element.css({
				width: width + 'px'
			})
            //Calculate OTP position
            if (window.BoostOTP) {
              BoostOTP.OTPButtons.bindEvents(this);
            }
		}
	}
})();

/* === Estimated Delivery badge enrichment for Boost-rendered cards ===
   Boost replaces {{stockStatus}} with a <div data-est-delivery-placeholder
   data-handle="..."> when no variants are in stock. This watcher batches
   handles, fetches the resolved metafield text from the globo.alsobought
   search view, and swaps the placeholder for the badge (or removes it if
   the metafield is empty/missing). */
(function () {
  var PLACEHOLDER_SELECTOR = '[data-est-delivery-placeholder]';
  var DELIVERY_ICON = 'https://cdn.shopify.com/s/files/1/0606/2909/0544/files/Estimated_Delivery.svg?v=1748381776';
  var SHOP_URL = window.location.origin;
  var cache = Object.create(null); // handle -> text ('' means no metafield)
  var pending = new Set();
  var scanTimer = null;
  var fetchTimer = null;

  function escHtml(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;')
      .replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  function badgeHTML(text) {
    return '<div class="icon__with__text"><div class="instock__image wd">' +
      '<img src="' + DELIVERY_ICON + '"></div>' +
      '<span class="instock__text">' + escHtml(text) + '</span></div>';
  }

  function patch() {
    var nodes = document.querySelectorAll(PLACEHOLDER_SELECTOR);
    if (!nodes.length) return;
    var needFetch = false;
    nodes.forEach(function (el) {
      var handle = el.getAttribute('data-handle');
      if (!handle) { el.remove(); return; }
      if (cache[handle] !== undefined) {
        if (cache[handle]) {
          el.outerHTML = badgeHTML(cache[handle]);
        } else {
          el.remove();
        }
      } else {
        pending.add(handle);
        needFetch = true;
      }
    });
    if (needFetch) scheduleFetch();
  }

  function scheduleScan() {
    if (scanTimer) return;
    scanTimer = setTimeout(function () { scanTimer = null; patch(); }, 30);
  }

  function scheduleFetch() {
    if (fetchTimer) return;
    fetchTimer = setTimeout(flush, 50);
  }

  function flush() {
    fetchTimer = null;
    if (!pending.size) return;
    var handles = Array.from(pending);
    pending = new Set();
    var payload = new URLSearchParams();
    payload.append('q', 'handles:' + handles.join('|'));
    payload.append('view', 'globo.alsobought');
    payload.append('type', 'product');
    fetch(SHOP_URL + '/search', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        'Accept': 'text/html'
      },
      body: payload
    }).then(function (res) {
      return res.ok ? res.json() : [];
    }).then(function (data) {
      var found = Object.create(null);
      (Array.isArray(data) ? data : []).forEach(function (p) {
        found[p.handle] = p.estimated_delivery || '';
      });
      handles.forEach(function (h) {
        cache[h] = (found[h] !== undefined) ? found[h] : '';
      });
      patch();
    }).catch(function () {
      handles.forEach(function (h) { cache[h] = ''; });
      patch();
    });
  }

  var observer = new MutationObserver(scheduleScan);
  observer.observe(document.body, { childList: true, subtree: true });
  scheduleScan();
})();

